export const BookingsByBookingDates = {
  en: {
    'Paid Bookings By Booking Dates': 'Paid Bookings By Booking Dates',
    Date: 'Date',
    Count: 'Count',
    From: 'From',
    Till: 'Till (Not Including)',
    'No Data Provided': 'No Data Provided',
  },
  uk: {
    'Paid Bookings By Booking Dates': 'Сплачені бронювання по датах бронювання',
    Date: 'Дата',
    Count: 'Кількість',
    From: 'Від',
    Till: 'До (Не включаючи)',
    'No Data Provided': 'Дані відсутні',
  },
};
